// extracted by mini-css-extract-plugin
export var dataCell = "_jq-2";
export var dataRow = "_jq-0";
export var headerRow = "_jq-1";